/**
 * Function that returns a an object with the property valid if a user can be
 * merged and a reason if it cannot
 *
 * @param user - The user object to validate
 * @returns UserMergeValidity
 */
export function validateIfUserCanMerge(user) {
    var _a;
    const isUserEndUser = ((_a = user.roles) === null || _a === void 0 ? void 0 : _a.length) === 1 && user.roles.includes('enduser');
    if (!isUserEndUser) {
        return {
            valid: false,
            reason: 'Only End Users can be merged',
        };
    }
    return {
        valid: true,
        reason: '',
    };
}
